<script>
  import Bleed from "$lib/components/Bleed.svelte";
  import Icon from "$lib/components/Icon.svelte";

  /** @type {"default" | "warning"} */
  export let variant;

  export let title;
  export let bodyText;
  export let additionalInformationLink;
  export let icon = "caution";
  export let showClose = true;
  export let isOpen = false;
  export let fullWidth = true;

  function close() {
    isOpen = false;
  }

  let centerDiv = fullWidth
    ? "w-full bottom-0 left-0"
    : "w-312 lg:w-806 h-288 lg:h-[207px] top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2";

  let fullWidthClasses = "";
  if (variant === "warning") {
    fullWidthClasses += "bg-marigold-400";
  } else if (variant === "default") {
    fullWidthClasses += "bg-neutral-100";
  }
</script>

<Bleed {fullWidth} {fullWidthClasses}>
  <div
    data-testid="banner"
    class="fixed z-10 justify-center py-16 lg:py-24 px-24 lg:px-72 {centerDiv}"
    class:bg-marigold-400={variant === "warning"}
    class:bg-neutral-100={variant === "default"}
    class:border-2={!fullWidth}
    class:border-neutral-300={!fullWidth}
    class:lg:px-[70px]={!fullWidth}
    class:md:py-24={fullWidth}
    class:hidden={!isOpen}
    aria-labelledby="banner-title"
    aria-describedby="banner-body"
    role="dialog"
  >
    <div class="gap-16 flex flex-col">
      <div class="flex flex-row w-full">
        {#if title}
          <h2
            id="banner-title"
            class="text-black w-full flex flex-row items-center gap-16 font-bold text-size-14 lg:text-size-base"
          >
            <Icon type={icon} leading />
            {title}
          </h2>
        {/if}
      </div>
      <div
        id="banner-body"
        class="text-black text-size-12 lg:text-size-14 flex flex-col gap-16 lg:gap-8 mx-auto lg:mx-0 w-full"
        class:lg:w-[75%]={fullWidth}
      >
        {bodyText}
        <div class="flex flex-col lg:flex-row">
          {#if additionalInformationLink}
            <a
              data-sveltekit-reload
              data-cy="additional-information-link"
              href={additionalInformationLink.fields.url}
              class="text-black font-bold hover:!no-underline focus:!no-underline hover:bg-none focus:bg-none my-auto"
              >{additionalInformationLink.fields.text}</a
            >
          {/if}
          <div
            class="flex flex-row flex-wrap justify-between lg:justify-normal gap-24 lg:ml-auto pt-16 lg:pt-0 lg:top-72 lg:right-72"
            class:md:justify-normal={fullWidth}
            class:lg:absolute={fullWidth}
          >
            <slot />
          </div>
        </div>
      </div>
      {#if showClose}
        <button
          class="absolute right-24 lg:top-24 text-neutral-900 hover:cursor-pointer"
          class:lg:right-72={!fullWidth}
          on:click={close}
          on:keypress={close}
          aria-label="Close dialog"
        >
          <Icon type="close" size="md" />
        </button>
      {/if}
    </div>
  </div></Bleed
>
